/**
 * Merge multiple refs in one `ref={}` prop.
 *
 * @example ref={mergeRefs([externalRef, internalRef])}
 * @param refs RefsArray<T>
 * @returns RefCallback<T>
 */ const mergeRefs = (refs)=>{
    return (value)=>{
        for (const ref of refs){
            if (typeof ref === 'function') {
                ref(value);
            } else if (ref !== null && ref !== undefined) {
                ref.current = value;
            }
        }
    };
};

export { mergeRefs };
//# sourceMappingURL=refs.js.map
